import type { LeasingFeatures } from '../types/LeasingFeatures';

export const phoebeFlags: LeasingFeatures = {
    leasings: {
        enabled: false,
        _description: 'Enables the whole leasing product including loading, main display',
        ticketing: {
            enabled: false,
            _description: 'Enables leasing ticketing feature',
        },
        papiCustomization: {
            enabled: false,
            _description: 'Enables usage of PAPI customization.',
        },
    },
    leasingEnhancement: {
        enabled: false,
        _description: 'Enable enhanced version of leasing',
    },
};
